export default {
  InService: 'inService',
  OutOfService: 'outOfService',
  OutForRepair: 'outForRepair',
  Scrapped: 'scrapped',
}
